import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1254.000000 1254.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)">

<path d="M9986 10204 c-12 -31 -7 -329 6 -342 8 -8 60 -12 168 -12 108 0 160
4 168 12 13 13 17 251 6 321 l-7 37 -167 0 c-144 0 -169 -2 -174 -16z"/>
<path d="M9012 9862 c-9 -7 -12 -69 -10 -278 l3 -269 270 0 270 0 3 255 c1
140 0 265 -3 278 l-5 22 -258 0 c-141 0 -263 -4 -270 -8z"/>
<path d="M9904 9417 c-2 -7 -3 -74 -2 -148 l3 -134 127 -3 c158 -3 153 -9 145
160 -3 65 -9 123 -12 128 -10 16 -255 13 -261 -3z"/>
<path d="M4390 9323 c-206 -20 -326 -46 -480 -103 -394 -146 -714 -433 -885
-793 -97 -205 -138 -382 -137 -592 0 -226 43 -417 133 -605 66 -136 102 -190
196 -291 101 -107 214 -191 338 -250 119 -56 170 -74 290 -101 84 -19 135 -21
770 -28 578 -6 688 -9 733 -22 178 -54 267 -191 232 -357 -34 -160 -183 -299
-385 -358 -54 -15 -141 -18 -915 -23 l-855 -5 -70 -24 c-84 -28 -135 -53 -194
-95 -35 -25 -273 -280 -440 -471 -44 -51 -176 -200 -181 -205 -48 -48 -243
-269 -254 -287 -7 -13 37 -14 355 -11 302 4 391 9 524 27 663 91 1157 235
1835 534 192 85 704 339 895 444 61 33 184 100 275 148 91 49 192 104 225 122
33 18 108 58 166 88 58 29 124 64 145 76 38 21 298 157 419 218 33 16 61 27
63 22 1 -4 -9 -39 -24 -77 -22 -59 -97 -269 -179 -506 -13 -38 -22 -68 -19
-68 2 0 75 66 162 147 86 81 220 206 297 277 131 123 251 235 300 281 124 116
280 262 294 274 10 9 58 52 107 97 49 45 105 95 124 112 l35 31 -679 1 -680 0
35 -36 c18 -19 80 -77 137 -127 56 -51 102 -96 102 -102 0 -6 -42 -28 -92 -49
-51 -22 -173 -74 -270 -117 -98 -44 -180 -79 -182 -79 -3 0 -8 17 -11 38 -21
131 -31 177 -57 257 -116 360 -414 624 -803 712 -59 14 -188 17 -835 22 -755
7 -766 7 -831 29 -199 66 -298 216 -271 409 26 189 166 345 372 415 l65 22
1275 6 c1402 7 1328 4 1531 70 214 70 411 212 534 385 49 69 265 483 265 508
0 16 -122 17 -1732 15 -953 0 -1749 -3 -1768 -5z"/>
<path d="M8680 9180 l-235 -5 0 -275 0 -275 270 0 270 0 3 274 c3 294 3 293
-48 289 -14 -2 -131 -5 -260 -8z"/>
<path d="M9382 8868 c-9 -9 -12 -82 -12 -275 l0 -263 26 -10 c39 -15 486 -13
507 3 16 11 17 37 15 282 l-3 270 -260 3 c-194 2 -264 -1 -273 -10z"/>
<path d="M7705 8420 c-118 -26 -142 -48 -431 -415 -113 -143 -217 -275 -232
-294 -140 -176 -191 -247 -194 -272 l-5 -29 611 0 c738 0 807 -6 986 -83 110
-48 185 -100 280 -197 184 -187 280 -441 266 -700 -18 -343 -201 -633 -491
-777 -191 -96 -187 -95 -770 -103 -559 -7 -550 -6 -677 -81 -58 -34 -90 -66
-225 -227 -186 -220 -166 -197 -331 -388 -118 -136 -170 -213 -155 -228 10
-10 1835 -7 1988 4 377 26 679 123 952 304 673 447 962 1358 686 2166 -156
459 -470 841 -888 1083 -182 105 -416 185 -653 223 -111 18 -650 29 -717 14z"/>
<path d="M6458 5777 c-210 -135 -226 -145 -405 -253 -671 -404 -1258 -651
-1897 -799 l-101 -24 652 0 c604 -1 660 0 750 18 113 22 248 68 348 118 352
177 660 559 775 961 9 34 15 62 11 62 -3 0 -63 -37 -133 -83z"/>
<path d="M2237 4148 c-173 -13 -283 -105 -321 -268 -20 -83 -20 -136 -1 -191
20 -57 55 -92 119 -120 47 -21 69 -23 301 -29 292 -6 305 -9 305 -81 0 -23 -8
-54 -17 -70 -34 -57 -46 -59 -441 -59 l-360 0 -16 -67 c-8 -38 -18 -85 -21
-105 l-7 -38 378 0 c224 0 402 4 439 11 79 14 171 65 212 117 43 57 74 143 80
229 8 98 -9 155 -58 197 -68 58 -113 66 -363 66 -230 0 -289 8 -306 40 -25 47
0 118 53 150 30 19 52 20 379 20 322 0 347 1 352 18 12 44 38 173 35 177 -8 7
-657 10 -742 3z"/>
<path d="M5706 4142 c-3 -9 -32 -150 -65 -312 -33 -162 -72 -349 -86 -415 -34
-155 -31 -217 13 -256 34 -31 87 -42 172 -37 l55 3 17 70 c23 97 22 105 -6
105 -43 0 -50 21 -33 102 9 40 47 223 86 407 39 184 70 335 69 337 -2 1 -51 4
-110 8 -95 5 -107 3 -112 -12z"/>
<path d="M8506 4028 c-14 -68 -30 -141 -34 -163 -8 -37 -10 -40 -38 -36 -16 2
-110 4 -209 5 -170 1 -182 0 -223 -22 -101 -54 -156 -142 -193 -308 -46 -206
-21 -302 91 -360 29 -15 60 -18 175 -18 132 -1 143 1 198 26 31 15 58 24 58
20 1 -4 2 -16 3 -27 1 -18 9 -20 75 -23 41 -2 78 1 82 5 7 7 49 187 83 358 32
165 138 650 142 657 3 4 -37 8 -89 8 l-94 0 -27 -122z m-149 -339 c47 -8 63
-15 63 -28 0 -13 -39 -207 -66 -333 -8 -35 -60 -48 -192 -48 -107 0 -157 12
-172 40 -24 44 2 216 43 296 18 35 57 64 102 75 47 11 152 10 222 -2z"/>
<path d="M3220 4003 c-6 -32 -17 -80 -23 -108 l-12 -50 -75 -5 -74 -5 -13 -60
c-20 -96 -22 -92 54 -94 37 -1 68 -3 69 -4 1 -1 -14 -74 -33 -162 -45 -212
-47 -224 -34 -271 13 -49 34 -75 81 -100 29 -15 59 -18 185 -18 l150 -1 17 65
c29 116 33 110 -82 110 -96 0 -100 1 -116 26 -16 24 -15 32 16 177 18 84 34
158 36 165 2 9 36 12 123 12 l120 0 11 54 c6 29 12 66 13 81 l2 28 -108 -1
c-83 -1 -109 2 -113 13 -3 7 3 57 14 109 l19 96 -108 0 -108 0 -11 -57z"/>
<path d="M9710 4003 c-6 -32 -17 -80 -23 -108 l-12 -50 -66 -3 -67 -3 -12 -65
c-7 -36 -11 -67 -9 -69 3 -2 28 -5 58 -7 29 -2 55 -8 58 -14 2 -7 -12 -88 -31
-181 -54 -253 -48 -305 36 -353 40 -23 52 -25 167 -24 88 1 125 5 131 14 10
16 34 129 29 134 -2 3 -36 6 -74 7 -84 3 -122 14 -130 40 -6 19 7 99 46 276
l20 91 73 7 c40 4 89 5 110 2 31 -4 37 -2 41 17 15 65 25 112 25 119 0 4 -47
7 -104 7 -58 0 -107 3 -110 8 -2 4 4 48 14 97 11 50 19 95 20 101 0 6 -34 11
-89 13 l-89 2 -12 -58z"/>
<path d="M3908 3842 c-97 -3 -98 -3 -104 -30 -3 -15 -10 -43 -15 -62 -19 -75
-35 -70 216 -70 150 0 233 -4 250 -12 27 -12 39 -40 33 -79 l-3 -24 -175 3
c-246 5 -333 -12 -403 -77 -61 -56 -97 -175 -77 -251 27 -99 93 -123 317 -118
164 3 159 2 266 56 4 2 7 -9 5 -24 l-3 -29 95 -3 96 -3 49 223 c28 126 51 258
53 303 3 71 1 84 -20 115 -13 20 -44 46 -73 60 -48 24 -58 25 -230 25 -99 0
-224 -1 -277 -3z m337 -468 c-9 -60 -13 -71 -33 -80 -30 -13 -317 -17 -341 -5
-31 17 -29 74 4 106 24 25 27 25 201 25 l176 0 -7 -46z"/>
<path d="M4798 3842 c-92 -3 -98 -4 -103 -25 -2 -12 -23 -112 -46 -222 -22
-110 -53 -260 -68 -333 -15 -73 -25 -135 -22 -137 2 -3 51 -5 108 -5 74 0 105
4 108 13 3 6 27 119 55 250 28 132 53 243 56 249 16 25 77 38 184 38 104 0
112 -1 135 -25 14 -13 25 -31 25 -39 0 -9 -12 -71 -26 -138 -63 -294 -70 -340
-59 -344 6 -3 56 -3 110 -2 l99 3 48 225 c28 128 49 255 50 295 3 110 -34 161
-141 191 -112 33 -355 5 -385 -45 -14 -23 -28 -11 -23 19 4 16 3 31 -1 32 -4
2 -51 2 -104 0z"/>
<path d="M6249 3841 c-116 -22 -208 -91 -252 -189 -31 -70 -56 -206 -57 -302
0 -77 3 -90 28 -128 19 -30 44 -51 82 -70 l55 -27 287 -3 286 -4 19 84 19 83
-257 5 c-230 4 -259 7 -277 23 -21 19 -33 61 -25 84 4 10 56 13 247 13 144 0
257 5 281 11 21 6 53 25 70 43 52 51 68 201 29 276 -17 34 -63 76 -99 91 -36
14 -370 22 -436 10z m310 -171 c24 -12 36 -49 27 -85 l-6 -25 -196 0 -196 0 7
28 c9 37 55 82 96 93 45 11 242 4 268 -11z"/>
<path d="M6963 3842 c-46 -1 -83 -7 -83 -13 0 -5 13 -58 29 -117 16 -59 58
-214 92 -344 42 -160 67 -238 76 -238 19 0 17 -7 -14 -51 -36 -49 -42 -52
-143 -58 l-85 -6 -22 -83 -22 -83 147 3 c117 2 154 7 183 21 72 36 92 63 374
502 18 28 92 142 164 254 72 112 130 206 127 208 -9 9 -241 2 -244 -7 -2 -4
-16 -28 -31 -52 -26 -40 -64 -101 -199 -323 -30 -49 -61 -96 -68 -104 -15 -16
-10 -31 -80 277 -45 197 -50 212 -70 212 -12 0 -28 1 -36 3 -7 1 -50 1 -95 -1z"/>
<path d="M8820 3783 c-7 -32 -15 -64 -17 -70 -4 -10 38 -13 189 -13 113 0 208
-5 226 -11 35 -12 55 -54 45 -99 l-5 -30 -192 0 c-225 0 -274 -10 -335 -68
-71 -69 -103 -214 -63 -291 28 -57 76 -74 215 -79 129 -5 211 7 263 39 41 25
44 24 44 -11 l0 -31 78 3 77 3 16 70 c53 226 92 426 92 476 0 68 -23 114 -73
144 -32 18 -55 20 -291 23 l-256 3 -13 -58z m407 -370 c-3 -10 -11 -41 -17
-70 -7 -30 -19 -54 -28 -59 -32 -13 -297 -17 -320 -5 -35 18 -30 84 7 122 l29
29 167 0 c154 0 166 -1 162 -17z"/>
<path d="M10232 3776 c-6 -36 -12 -69 -12 -73 0 -5 91 -8 203 -8 177 0 206 -2
230 -18 21 -14 27 -25 27 -55 0 -20 -4 -42 -8 -49 -5 -8 -72 -12 -217 -15
-184 -3 -215 -6 -250 -23 -71 -35 -107 -84 -131 -175 -27 -106 -4 -178 69
-218 27 -14 59 -17 187 -17 150 0 158 1 209 28 29 15 55 27 57 27 2 0 4 -11 4
-24 0 -30 16 -36 95 -36 l64 0 10 38 c5 20 31 143 57 272 51 253 52 280 11
341 -41 61 -55 64 -337 67 l-255 3 -13 -65z m405 -368 c-4 -13 -9 -42 -13 -66
-4 -29 -14 -47 -28 -54 -12 -7 -80 -14 -159 -16 -153 -5 -187 5 -187 54 0 35
27 83 53 94 12 5 93 9 181 9 l158 1 -5 -22z"/>
<path d="M5650 2569 c-286 -12 -673 -37 -919 -60 -195 -18 -543 -56 -565 -62
-5 -2 964 -3 2152 -2 1188 0 2159 1 2158 2 -11 11 -690 79 -976 97 -526 35
-1347 46 -1850 25z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
